import React, { Component } from 'react';
import './styles.css';

class DarkGreyCircle extends Component {
	render() {
		return (
			<div className="submission-stepper-item-layout-dark-grey-circle">
				{this.props.children}
			</div>
		);
	}
}

export default DarkGreyCircle;
